import { render, staticRenderFns } from "./TableReadCitasMedicas.vue?vue&type=template&id=0c5275c0&scoped=true"
import script from "./TableReadCitasMedicas.vue?vue&type=script&lang=js"
export * from "./TableReadCitasMedicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5275c0",
  null
  
)

export default component.exports